import { css, type Theme } from "@emotion/react";

// The auth column is a centered flex column, and Message renders its box inside an
// animation wrapper that takes no styles — so this element has to be the one that
// stretches, otherwise the banner shrink-wraps to its copy and sits narrower than
// the fields below it.
export const wrapper = (theme: Theme) => css`
  align-self: stretch;
  width: 100%;
  margin-bottom: ${theme.ds5.spacing.gap.medium};
  // The column centers its text, which reads badly next to the icon.
  text-align: start;
`;
